import {
    ContactRound, IdCard, IdCardLanyard, Cake, Syringe, BriefcaseBusiness, Award, Edit, Smartphone, CirclePlus, CircleMinus,
    Landmark, CreditCard, Wallet, MapPinHouse, LandPlot, ShieldUser,
    CircleUser,
    CalendarFold,
    UserRound,
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Link } from "@tanstack/react-router";
import { Separator } from "@/components/ui/separator";
import type { CombinedUser } from "@/lib/collections/workerProfile-Users/getUserWithProfile";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";

type InfoCollaboratorProps = {
    user: CombinedUser;
};

const InfoCollaborator = ({ user }: InfoCollaboratorProps) => {
    const [info, setInfo] = useState(false)
    const { userRoles } = useAuth();

    return (
        <>
            <Breadcrumb>
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <ContactRound />
                        <BreadcrumbLink asChild>
                            <BreadcrumbPage>Directorio</BreadcrumbPage>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to="/directory">Colaboradores</Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage className="hidden sm:block">{user.name}</BreadcrumbPage>
                        <BreadcrumbPage className="block sm:hidden "> <CircleUser className="w-5 h-5" /> </BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>

            <div className="py-6 pb-24 flex justify-center  px-4">
                <Card className="w-full max-w-2xl overflow-hidden shadow-lg">
                    <CardContent className="px-6 py-6">
                        {/* Datos de usuario */}
                        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 mb-6">
                            <img
                                src={user.avatarUrl}
                                className="w-20 h-20 rounded-full object-cover border-2 shrink-0"
                                alt=""
                            />
                            <div className="text-center sm:text-left w-full wrap-break-word">
                                <h1 className="text-xl font-outfit font-semibold">{user.name}</h1>
                                <p className="text-base font-outfit  text-gray-500">{user.email}</p>
                                <p className="text-gray-400 text-sm font-nunito">
                                    {user.profile?.rolCorp || "No disponible"} - {user.profile?.colabCorpCode || "No disponible"}
                                </p>
                            </div>
                            <Link to="/directory/$id/edit" params={{ id: user.id }} hidden={!(userRoles?.isAdmin || userRoles?.isRRHH)}>
                                <div className="flex items-center justify-center gap-2 w-full sm:w-auto bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-yellow-600 transition cursor-pointer">
                                    <Edit />
                                    <span>Editar</span>
                                </div>
                            </Link>


                        </div>

                        <div className="flex flex-col gap-6">

                            <div>
                                <h3 className={styleH3}><IdCardLanyard /> Código de colaborador:</h3>
                                <p className={styleP}>{user.profile?.colabCorpCode || "No disponible"}</p>
                                <Separator />
                            </div>

                            <div>
                                <h3 className={styleH3}><Smartphone /> Teléfono:</h3>
                                <p className={styleP}>{user.profile?.phone1 || "No disponible"}</p>
                                <Separator />
                            </div>

                            <div>
                                <h3 className={styleH3}><Cake /> Fecha de nacimiento:</h3>
                                <p className={styleP}>
                                    {user.profile?.birthday
                                        ? new Date(user.profile.birthday).toLocaleDateString('es-ES', {
                                            timeZone: 'UTC',
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        })
                                        : "No disponible"}
                                </p>
                                <Separator />
                            </div>

                            <div>
                                <h3 className={styleH3}><Syringe /> Tipo de sangre:</h3>
                                <p className={styleP}>{user.profile?.bloodType || "No disponible"}</p>
                                <Separator />
                            </div>

                            <div>
                                <h3 className={styleH3}><BriefcaseBusiness /> Funciones:</h3>
                                <p className={styleP}>
                                    {user.profile?.keyFunction && user.profile.keyFunction.length > 0
                                        ? user.profile.keyFunction
                                            .filter(f => f?.trim())
                                            .map((func, index) => (
                                                <span key={index}>
                                                    {index + 1}. {func}{" "}
                                                </span>
                                            ))
                                        : "No disponible"
                                    }
                                </p>
                                <Separator />
                            </div>

                            <div>
                                <h3 className={styleH3}><Award /> Logros:</h3>
                                <p className={styleP}>
                                    {user.profile?.archievement && user.profile.archievement.length > 0
                                        ? user.profile.archievement
                                            .filter(f => f?.trim())
                                            .map((func, index) => (
                                                <span key={index}>
                                                    {index + 1}. {func}{" "}
                                                </span>
                                            ))
                                        : "No disponible"
                                    }
                                </p>
                                <Separator />
                            </div>

                            <Button hidden={info} onClick={() => setInfo(true)} className="cursor-pointer" disabled={!(userRoles?.isAdmin || userRoles?.isRRHH)} > <CirclePlus /> Más Información</Button>

                            {info && (
                                <>

                                    <div>
                                        <h3 className={styleH3}><IdCard /> Número de cédula:</h3>
                                        <p className={styleP}>{user.profile?.colabDniCode || "No disponible"}</p>
                                        <Separator />
                                    </div>

                                    <div>
                                        <h3 className={styleH3}><Smartphone /> Teléfono 2:</h3>
                                        <p className={styleP}>{user.profile?.phone2 || "No disponible"}</p>
                                        <Separator />
                                    </div>

                                    <div>
                                        <h3 className={styleH3}><Landmark /> Banco:</h3>
                                        <p className={styleP}>{user.profile?.bank || "No disponible"}</p>
                                        <Separator />
                                    </div>

                                    <div>
                                        <h3 className={styleH3}><CreditCard /> Numero de cuenta (banco): </h3>
                                        <p className={styleP}>{user.profile?.bankAccountNumber || "No disponible"}</p>
                                        <Separator />
                                    </div>

                                    <div>
                                        <h3 className={styleH3}><Wallet /> Tipo de cuenta (banco): </h3>
                                        <p className={styleP}>{user.profile?.bankAccountType || "No disponible"}</p>
                                        <Separator />
                                    </div>

                                    <div>
                                        <h3 className={styleH3}><MapPinHouse />Dirección: </h3>
                                        <p className={styleP}>{user.profile?.address || "No disponible"}</p>
                                        <Separator />
                                    </div>

                                    <div>
                                        <h3 className={styleH3}><LandPlot />Área (departamento): </h3>
                                        <p className={styleP}>{user.profile?.area || "No disponible"}</p>
                                        <Separator />
                                    </div>

                                    <div>
                                        <h3 className={styleH3}><CalendarFold /> Fecha de ingreso:</h3>
                                        <p className={styleP}>
                                            {user.profile?.joinDate
                                                ? new Date(user.profile.joinDate).toLocaleDateString('es-ES', {
                                                    timeZone: 'UTC',
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric'
                                                })
                                                : "No disponible"}
                                        </p>

                                        <Separator />
                                    </div>

                                    {/* fecha en la que salio el colaborador de la empresa */}
                                    {/* <div>
                                        <h3 className={styleH3}><CalendarFold /> Fecha de salida:</h3>
                                        <p className={styleP}>
                                            {user.profile?.leaveDate
                                                ? new Date(user.profile.leaveDate).toLocaleDateString('es-ES', {
                                                    timeZone: 'UTC',
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric'
                                                })
                                                : "No disponible"}
                                        </p>

                                        <Separator />
                                    </div> */}


                                    <div>
                                        <h3 className={styleH3}><UserRound /> Estado: </h3>
                                        <p className={styleP}>
                                            {user.profile?.isActive ? "Activo" : "Inactivo"}
                                        </p>
                                        <Separator />
                                    </div>



                                    <div>
                                        <h3 className={styleH3}><ShieldUser />Superior Inmediato: </h3>
                                        <p className={styleP}>{user.profile?.supervisorName || "No disponible"}</p>
                                        <Separator />
                                    </div>


                                    <Button disabled={!info} onClick={() => (setInfo(false))} className="cursor-pointer"> <CircleMinus /> Mostrar menos información</Button>
                                </>
                            )}
                        </div>
                    </CardContent>
                </Card>
            </div>
        </>
    );
};
const styleP = "text-gray-500 font-nunito text-base break-words";
const styleH3 = "text-gray-700 font-outfit text-lg mb-2 flex items-center gap-2";

export default InfoCollaborator;

